import { $, aviso, avisoHtml, esc, escribir, limpiar, noContesto, num, pedir, RECHAZO, repintar, rpc, sb, pedirTodo, ordenarPor } from './nucleo';
import { modoSerie } from './recepcion';
import { pintarSelectProductos } from './pedidos';
import { soyAdmin } from './aprobaciones';

// ---------- catálogos ----------
export let PRODUCTOS = [], SUBCATS = [], MARCAS = [], LINEAS = [], COLORES = [];

//  Lo que NO se pudo leer, que no es lo mismo que lo que no hay: mientras
//  alguna de estas tenga texto, la pantalla lo dice y las puertas que dependen
//  de ESE pedazo del catálogo quedan cerradas.
//
//  Son tres y no una porque frenan cosas distintas: con una sola, una caída de
//  `colores` (que Recepción no usa) dejaba el remito sin poder cargarse.
//  Cerrar de más es el mismo bug al revés.
export let ERROR_CATALOGO = '',     //  categorías, marcas, subcategorías, líneas y colores: el ALTA de producto
           ERROR_PROVEEDORES = '',  //  proveedores: el select de Recepción
           ERROR_PRODUCTOS = '';    //  `v_precios`: Recepción y Pedidos
//  Una cuarta que NO es de lectura: crear una subcategoría, marca, línea o color no
//  contestó y el caché no sabe si existe. El catálogo SÍ se leyó, así que no se
//  reusa `ERROR_CATALOGO` (su cartel sería falso).
let CREACION_INCIERTA = '';
//  Lo que la ficha necesita y `v_precios` no trae (0089, D204): marca, stock
//  mínimo, código de Apple y los ids. Sale de `productos`. Que no se pueda
//  leer no frena Recepción ni Pedidos: sólo la ficha (y la columna del
//  código de Apple, que dice que no se pudo leer en vez de «—»).
let ERROR_FICHA = '';

//  No es un catálogo vacío: el texto nombra lo que existe y no se pudo ver.
const porQue = (e: string, hay: string) =>
  `No se pudo leer el catálogo (${esc(e)}). <b>No es que no haya ${hay}: ` +
  'es que no se pudieron leer.</b> Cambiá de pestaña y volvé, o recargá ' +
  'con Ctrl+F5.';

//  La puerta de Recepción la cierran dos de los tres errores. El proveedor
//  entra aunque el botón de agregar no lo lea: sin proveedor el remito no se
//  puede registrar ni imputar. Es una función sola porque la carga de productos
//  corre también por su cuenta (al abrir Pedidos, al cambiar un precio) y el
//  estado del botón debe salir siempre de la misma cuenta.
//  Ojo: repintar un `<select>` borra lo ya elegido sin disparar `onchange` (en
//  Recepción, perder el proveedor a mitad de un remito pierde la imputación de
//  las líneas). Usar `repintar()` del núcleo.


function puertaRecepcion(){
  //  El alta de producto NO entra acá: que no se hayan podido leer los
  //  colores no tiene nada que ver con recibir mercadería.
  const roto = ERROR_PROVEEDORES || ERROR_PRODUCTOS;
  //  El cartel nombra lo que de verdad no se pudo leer.
  const hay = ERROR_PROVEEDORES && ERROR_PRODUCTOS ? 'proveedores ni productos'
            : ERROR_PROVEEDORES ? 'proveedores' : 'productos';
  //  `#btnRec` no se toca acá: lo gobierna `recepcion.ts`; dos módulos
  //  peleando por el mismo botón es peor que uno.
  $('#btnRecAgregar').disabled = !!roto;
  if (roto) avisoHtml('#recCatMsg', 'bad', porQue(roto, hay));
  else limpiar('#recCatMsg');
}

export async function cargarCatalogos(){
  const [prov, cats, marcas, subcats, lineas, colores] = await Promise.all([
    pedirTodo(() => sb.from('proveedores').select('id,nombre').eq('activo',true), { por: 'id', orden: ordenarPor('nombre', 'id') }),
    pedirTodo(() => sb.from('categorias').select('id,nombre,orden').eq('activo',true), { por: 'id', orden: ordenarPor('orden', 'id') }),
    //  Las marcas van TODAS (D213): la ficha muestra la del producto aunque
    //  esté dada de baja, y escribirla no intenta crearla de nuevo (el nombre
    //  es único). Las sugerencias son sólo las activas.
    pedirTodo(() => sb.from('marcas').select('id,nombre,activo'), { por: 'id', orden: ordenarPor('nombre', 'id') }),
    pedirTodo(() => sb.from('subcategorias').select('id,nombre,categoria_id').eq('activo',true), { por: 'id', orden: ordenarPor('nombre', 'id') }),
    pedirTodo(() => sb.from('lineas').select('id,nombre').eq('activo',true), { por: 'id', orden: ordenarPor('nombre', 'id') }),
    pedirTodo(() => sb.from('colores').select('id,nombre').eq('activo',true), { por: 'id', orden: ordenarPor('nombre', 'id') })
  ]);

  //  Las seis consultas se miran por separado: cada pedazo cierra una puerta
  //  distinta. Ninguna de estas siete relaciones se tapa por permiso (RLS: las
  //  ve cualquier usuario activo), así que un `error` es una falla de verdad.
  const op = (arr, vacio = null) =>
    (vacio ? `<option value="">${vacio}</option>` : '') +
    (arr.data||[]).map(x=>`<option value="${x.id}">${esc(x.nombre)}</option>`).join('');
  const roto = '<option value="">no se pudo leer el catálogo</option>';

  //  ---- los proveedores: el select de Recepción ----
  ERROR_PROVEEDORES = prov.error ? prov.error.message : '';
  //  Un `<select>` vacío también es una afirmación: "No hay proveedores
  //  cargados" con la consulta caída manda a dar de alta uno que ya existe.
  //
  //  La opción vacía va primera y SIEMPRE: sin ella queda elegido el primer
  //  proveedor sin que nadie lo elija (ni el `required` ni el control de
  //  pantalla frenan: `Number('2')` no es falsy) y decide contra qué órdenes se
  //  imputa el remito (punto 7).
  repintar('#recProv', ERROR_PROVEEDORES ? roto
    : op(prov, (prov.data||[]).length
        ? '— elegí el proveedor —' : 'No hay proveedores cargados'));

  //  ---- los otros cinco: el alta de producto ----
  const falla = cats.error || marcas.error || subcats.error
             || lineas.error || colores.error;
  if (falla){
    ERROR_CATALOGO = falla.message;
    $('#pCat').innerHTML   = roto;
    //  Los tres cachés NO se tocan: quedan como la última lectura buena. Uno sin
    //  llenar haría que el alta mande a crear una subcategoría que existe y
    //  rebote con "duplicate key"; por eso se frena el alta entera.
    avisoHtml('#catMsg', 'bad', porQue(ERROR_CATALOGO, 'categorías ni marcas') +
      '<br>Mientras tanto no se pueden dar de alta productos: las marcas, subcategorías, ' +
      'líneas y colores que ya existen no están cargados.');
    $('#btnAltaProd').disabled = true;
  } else {
    //  El aviso del `submit` también se va. Se mira el TEXTO y no una bandera:
    //  `#prodMsg` lo comparten el alta y sus errores, y una bandera se
    //  desincroniza.
    if (($('#prodMsg').textContent || '').includes('No se pudo leer el catálogo'))
      limpiar('#prodMsg');
    if (($('#prodMsg').textContent || '').includes('No se sabe si se creó'))
      limpiar('#prodMsg');
    ERROR_CATALOGO = '';
    CREACION_INCIERTA = '';
    limpiar('#catMsg');
    $('#btnAltaProd').disabled = false;
    //  `repintar` y no `innerHTML` (regla 12): con `innerHTML` la categoría
    //  volvía en silencio a la primera opción y la subcategoría tecleada se
    //  creaba en otra categoría.
    repintar('#pCat', op(cats));
    SUBCATS = subcats.data || []; MARCAS = marcas.data || [];
    LINEAS = lineas.data || []; COLORES = colores.data || [];
  }

  pintarSugerencias();
  await cargarProductos();
}

//  Se llaman al abrir la pestaña: una lectura fallida se reintenta (si no hay
//  nada roto, no se consulta nada).
//
//  Son DOS y no una: abrir Recepción no debe releer los colores; con `colores`
//  caído, cada vuelta repintaba los dos selects.
export function reintentarRecepcion(){
  if (ERROR_PROVEEDORES) return cargarCatalogos();
  if (ERROR_PRODUCTOS)   return cargarProductos();
}
export function reintentarProductos(){
  if (ERROR_CATALOGO || CREACION_INCIERTA) return cargarCatalogos();
  if (ERROR_PRODUCTOS) return cargarProductos();
}

// Las cuatro son sugerencias, no una lista cerrada: se pueden escribir
// nuevas y se crean solas, igual que al importar por CSV.
function pintarSugerencias(){
  const dl = (arr) => arr.map(x=>`<option value="${esc(x.nombre)}">`).join('');
  // La subcategoría cuelga de la categoría: sólo se sugieren las de ésta.
  const cat = Number($('#pCat').value) || null;
  $('#dlSubcat').innerHTML = dl(SUBCATS.filter(s => !cat || s.categoria_id === cat));
  $('#dlMarca').innerHTML  = dl(MARCAS.filter(m => m.activo !== false));
  $('#dlLinea').innerHTML  = dl(LINEAS);
  $('#dlColor').innerHTML  = dl(COLORES);
}
$('#pCat').onchange = () => { $('#pSubcat').value = ''; pintarSugerencias(); };

// Busca por nombre sin distinguir mayúsculas; si no está, la crea.
// La base sólo deja crearlas a un admin, así que esto no abre nada.
async function idPorNombre(tabla: 'subcategorias' | 'marcas' | 'lineas' | 'colores',
                           cache: { id: number; nombre: string; categoria_id?: number }[],
                           nombre: string, extra: { categoria_id?: number } = {}){
  //  OJO: acá "no está en el caché" quiere decir "no existe" y se crea; eso sólo
  //  es cierto si el caché se pudo llenar. El freno por catálogo roto está en el
  //  `submit` (único camino que llega acá), no acá.
  const n = (nombre||'').trim();
  if (!n) return null;
  const igual = (a,b) => a.localeCompare(b, 'es', { sensitivity:'base' }) === 0;
  const ya = cache.find(x => igual(x.nombre, n) &&
    (extra.categoria_id == null || x.categoria_id === extra.categoria_id));
  if (ya) return ya.id;
  // `select()` a secas devuelve las columnas de la tabla: `marcas`, `lineas` y
  // `colores` no tienen categoria_id, no pedírselo.
  const { data, error } = await escribir(sb.from(tabla).insert({ nombre:n, ...extra } as any)
    .select().single());
  //  Si la base no contestó, la fila quizá quedó creada y el caché no lo sabe
  //  (D92): se marca el catálogo como no leído y al volver a la pestaña
  //  `reintentarProductos` lo relee.
  if (noContesto(error)){
    CREACION_INCIERTA = `${tabla.slice(0,-1)} "${n}"`;
    throw new Error(`No se sabe si se creó ${tabla.slice(0,-1)} "${n}": ${error.message} ` +
      'Cambiá de pestaña y volvé antes de dar de alta, así se relee el catálogo.');
  }
  if (error) throw new Error(`No se pudo crear ${tabla.slice(0,-1)} "${n}": ${error.message}`);
  cache.push(data as any);
  return (data as { id: number }).id;
}

export async function cargarProductos(){
  // Desde 0022 el precio no vive en la ficha del producto sino en `precios`,
  // con su fecha de vigencia. v_precios es el producto con su precio de hoy
  // y el que tenga programado.
  const [{ data, error }, ficha] = await Promise.all([
    pedirTodo(() => sb.from('v_precios').select('*')
      .eq('activo',true), { por: 'producto_id', orden: ordenarPor('codigo', 'producto_id') }),
    pedirTodo(() => sb.from('productos')
      .select('id,marca_id,subcategoria_id,linea_id,color_id,stock_minimo,nro_parte')
      .eq('activo',true), { por: 'id', orden: ordenarPor('id') })
  ]);
  ERROR_FICHA = ficha.error ? ficha.error.message : '';
  const deFicha = new Map((ficha.data || []).map((f: any) => [f.id, f]));

  //  Lo mismo que arriba, en el renglón que más duele: este select llena el
  //  producto de Recepción, y una lista caída mostrada como vacía frena
  //  mercadería (D79). `v_precios` no se tapa por permiso.
  if (error){
    ERROR_PRODUCTOS = error.message;
    PRODUCTOS = [];
    if (document.getElementById('peProd')) pintarSelectProductos();
    repintar('#recProd', '<option value="">no se pudieron leer los productos</option>');
    pintarProductos();
    modoSerie();
    puertaRecepcion();
    return;
  }

  ERROR_PRODUCTOS = '';
  //  `ficha` es null si no se pudo leer: la columna y el ✎ lo dicen.
  PRODUCTOS = (data || []).map(p => ({ ...p, id: p.producto_id,
    ficha: ERROR_FICHA ? null : (deFicha.get(p.producto_id) ?? null) }));
  if (document.getElementById('peProd')) pintarSelectProductos();
  //  La opción vacía va primera, igual que la del proveedor: sin ella se puede
  //  agregar al remito un producto que nadie eligió.
  repintar('#recProd', PRODUCTOS.length
    ? '<option value="">— elegí el producto —</option>' +
      PRODUCTOS.map(p=>`<option value="${p.id}" data-serie="${p.es_serializado}">${esc(p.codigo)} — ${esc(p.descripcion)}</option>`).join('')
    : '<option value="">No hay productos cargados todavía</option>');
  pintarProductos();
  modoSerie();
  puertaRecepcion();
}

function pintarProductos(){
  //  La tabla también afirma: "Todavía no hay productos" sobre una consulta
  //  caída es la misma mentira que el select.
  if (ERROR_PRODUCTOS){
    $('#tblProd').innerHTML = `<tr><td colspan="10" class="vacio">` +
      `No se pudieron leer los productos (${esc(ERROR_PRODUCTOS)}). ` +
      `No quiere decir que no haya ninguno.</td></tr>`;
    return;
  }
  const q = ($('#buscaProd').value||'').toLowerCase();
  const f = PRODUCTOS.filter(p => !q || [p.codigo, p.descripcion, p.modelo,
      p.categoria, p.subcategoria, p.linea, p.color, p.ficha?.nro_parte]
    .some(v => (v||'').toLowerCase().includes(q)));
  const apple = (p) => !p.ficha ? '<span class="chip c-warn" title="No se pudo leer la ficha del producto">?</span>'
    : p.ficha.nro_parte ? `<span class="mono">${esc(p.ficha.nro_parte)}</span>` : '—';
  //  El ✎ es de quien administra (`app.es_admin()`, como el alta). La base
  //  igual se lo rechaza a cualquier otro: la pantalla sólo esconde.
  const editar = soyAdmin();
  $('#tblProd').innerHTML = f.map(p=>`
    <tr><td class="mono">${esc(p.codigo)}</td><td>${esc(p.descripcion)}</td>
        <td>${apple(p)}</td>
        <td>${esc(p.categoria ?? '—')}</td>
        <td>${esc(p.subcategoria ?? '—')}</td>
        <td>${esc(p.linea ?? '—')}</td>
        <td>${esc(p.color ?? '—')}</td>
        <td class="num">${p.precio_vigente != null
              ? num(p.precio_vigente)
              : '<span class="chip c-warn">sin precio</span>'}</td>
        <td>${p.es_serializado
              ? '<span class="chip c-pen">IMEI</span>'
              : '<span class="chip c-warn">cantidad</span>'}</td>
        <td>${editar ? `<button class="b b-sec" type="button" data-editar="${p.id}"
              aria-label="Editar ${esc(p.codigo)}" title="Editar el producto">✎</button>` : ''}</td></tr>
  `).join('') || '<tr><td colspan="10" class="vacio">Todavía no hay productos</td></tr>';
}
$('#buscaProd').oninput = pintarProductos;
$('#tblProd').onclick = (e: Event) => {
  const b = (e.target as HTMLElement).closest('[data-editar]') as HTMLElement | null;
  if (b) abrirFicha(Number(b.dataset.editar));
};

// ---------- alta de producto ----------
$('#formProd').onsubmit = async e => {
  e.preventDefault();
  limpiar('#prodMsg');
  //  El botón está apagado, pero un Enter en cualquier input manda el
  //  formulario igual: la puerta se cierra también acá.
  if (ERROR_CATALOGO){
    aviso('#prodMsg','bad', 'No se pudo leer el catálogo, así que no se sabe qué ' +
      'marcas, subcategorías, líneas y colores ya existen. Cambiá de pestaña y volvé, ' +
      'o recargá con Ctrl+F5, antes de dar de alta.');
    return;
  }
  if (CREACION_INCIERTA){
    aviso('#prodMsg','bad', `No se sabe si se creó ${CREACION_INCIERTA}, porque la base ` +
      'no contestó. Cambiá de pestaña y volvé antes de dar de alta, así se relee ' +
      'el catálogo y no se crea dos veces.');
    return;
  }
  const cat = Number($('#pCat').value);

  let subcat_id, marca_id, linea_id, color_id;
  try {
    subcat_id = await idPorNombre('subcategorias', SUBCATS, $('#pSubcat').value, { categoria_id: cat });
    marca_id  = await idPorNombre('marcas',  MARCAS,  $('#pMarca').value);
    linea_id  = await idPorNombre('lineas',  LINEAS,  $('#pLinea').value);
    color_id  = await idPorNombre('colores', COLORES, $('#pColor').value);
  } catch (err){ aviso('#prodMsg','bad', err.message); return; }

  const { data: nuevo, error } = await escribir(sb.from('productos').insert({
    codigo         : $('#pCodigo').value.trim().toUpperCase(),
    descripcion    : $('#pDesc').value.trim(),
    categoria_id   : cat,
    subcategoria_id: subcat_id,
    marca_id       : marca_id,
    linea_id       : linea_id,
    color_id       : color_id,
    modelo         : $('#pModelo').value.trim() || null,
    capacidad      : $('#pCapacidad').value.trim() || null,
    stock_minimo   : Number($('#pStockMin').value || 0),
    //  0089 · un código de Apple va en un solo producto: si ya lo tiene
    //  otro, la base rechaza el alta y lo dice (D204).
    nro_parte      : $('#pNroParte').value.trim() || null,
    es_serializado : $('#pSerie').value === 'true'
  }).select('id').single());
  //  Si la base no contestó, el producto quizá quedó dado de alta (D92): lo
  //  tecleado se queda y la lista se relee.
  if (noContesto(error)){
    aviso('#prodMsg','warn', error.message +
      ' Buscá el código en la lista antes de darlo de alta de nuevo.');
    cargarProductos();
    return;
  }
  if (error){ aviso('#prodMsg','bad', error.message); return; }

  // El precio es una fila de `precios`, no una columna del producto: el
  // inicial rige desde ahora y los siguientes se cargan en Precios.
  let extra = '';
  if ($('#pPrecio').value){
    const { error: e2 } = await rpc('fijar_precios', {
      p_items: [{ producto_id: nuevo.id, precio: Number($('#pPrecio').value) }],
      p_vigencia_desde: null, p_nota: 'Precio inicial del alta' });
    //  DOS causas y no una (D87): si la base dice que no, el precio NO quedó;
    //  si no CONTESTA, no se sabe de qué lado del corte quedó, y afirmar "SIN
    //  precio" llevaría a cargar uno encima de otro que quizá ya está. El
    //  rechazo se reconoce por el CÓDIGO del envoltorio de `rpc()`, no por el
    //  texto (D68).
    extra = !e2 ? ' Con su precio inicial vigente.'
          : e2.code === RECHAZO
          ? ' Ojo: no se sabe si el precio quedó cargado, porque la base no ' +
            'contestó. Fijate en Precios antes de cargarlo de nuevo.'
          : ` Ojo: el producto quedó SIN precio (${e2.message}).`;
  } else {
    extra = ' Todavía no tiene precio: cargalo en Precios antes de venderlo.';
  }
  aviso('#prodMsg', extra.startsWith(' Ojo') ? 'warn' : 'ok', 'Producto dado de alta.' + extra);
  $('#formProd').reset();
  pintarSugerencias();
  cargarProductos();
};

// ---------- la ficha: editar un producto (0089, D204) ----------
//  Se abre con el ✎ de la lista y guarda por `editar_producto`, que pide
//  administrador y deja el historial. Se manda SÓLO lo que se cambió
//  respecto de lo que se abrió: si alguien cambió otra cosa mientras tanto,
//  no se la pisa con lo viejo.
let EDITANDO: any = null;

const igualNombre = (a: string | null | undefined, b: string | null | undefined) =>
  (a ?? '').trim().localeCompare((b ?? '').trim(), 'es', { sensitivity: 'base' }) === 0;

function pintarSubcatFicha(){
  const cat = Number($('#edCat').value) || null;
  $('#dlEdSubcat').innerHTML = SUBCATS.filter(s => !cat || s.categoria_id === cat)
    .map(x => `<option value="${esc(x.nombre)}">`).join('');
}
//  Como en el alta: la subcategoría vieja es de la otra categoría.
$('#edCat').onchange = () => { $('#edSubcat').value = ''; pintarSubcatFicha(); };

//  El select lleva la opción del producto aunque esté dada de baja en el
//  catálogo: si no, quedaría elegida otra sin que nadie la elija, y se
//  guardaría.
function conOpcion(sel: string, html: string, id: number | null, nombre: string | null){
  $(sel).innerHTML = html;
  if (id != null && ![...$(sel).options].some((o: HTMLOptionElement) => Number(o.value) === id))
    $(sel).insertAdjacentHTML('beforeend', `<option value="${id}">${esc(nombre ?? '(dada de baja)')}</option>`);
  $(sel).value = id == null ? '' : String(id);
}

function cerrarFicha(){
  EDITANDO = null;
  $('#fichaProd').classList.add('oculto');
  limpiar('#edProdMsg');
}
$('#btnEdCancelar').onclick = cerrarFicha;

function abrirFicha(id: number){
  limpiar('#catProdMsg');
  limpiar('#edProdMsg');
  const p = PRODUCTOS.find(x => x.id === id);
  if (!p) return;
  //  Abrirla sin lo que el producto tiene sería guardar sobre datos que no
  //  se ven (D79): no se abre.
  if (!p.ficha){
    aviso('#catProdMsg', 'bad', `No se pudo leer la ficha de los productos (${ERROR_FICHA}), así que ` +
      'no se puede editar. Cambiá de pestaña y volvé, o recargá con Ctrl+F5.');
    return;
  }
  if (ERROR_CATALOGO){
    aviso('#catProdMsg', 'bad', 'No se pudo leer el catálogo (categorías, marcas…), así que no se ' +
      'puede editar un producto. Cambiá de pestaña y volvé, o recargá con Ctrl+F5.');
    return;
  }
  EDITANDO = p;
  $('#edTitulo').textContent = p.codigo;
  $('#edCodigo').value    = p.codigo;
  $('#edDesc').value      = p.descripcion;
  conOpcion('#edCat',   $('#pCat').innerHTML,   p.categoria_id,   p.categoria);
  //  La marca se escribe como la línea (D213), y se manda sólo si cambió lo
  //  que se mostró.
  p.marcaMostrada = MARCAS.find(m => m.id === p.ficha.marca_id)?.nombre ?? '';
  $('#edMarca').value = p.marcaMostrada;
  $('#edPrecio').value    = p.precio_vigente ?? '';
  $('#edSerie').value     = String(!!p.es_serializado);
  $('#edSubcat').value    = p.subcategoria ?? '';
  $('#edLinea').value     = p.linea ?? '';
  $('#edColor').value     = p.color ?? '';
  $('#edModelo').value    = p.modelo ?? '';
  $('#edCapacidad').value = p.capacidad ?? '';
  $('#edNroParte').value  = p.ficha.nro_parte ?? '';
  $('#edStockMin').value  = p.ficha.stock_minimo ?? 0;
  pintarSubcatFicha();
  $('#fichaProd').classList.remove('oculto');
  $('#fichaProd').scrollIntoView({ block: 'start' });
  $('#edDesc').focus();
}

$('#formEdProd').onsubmit = async e => {
  e.preventDefault();
  limpiar('#edProdMsg');
  const p = EDITANDO;
  if (!p) return;
  //  Las mismas puertas que el alta: con el catálogo sin leer, «no está en el
  //  caché» no quiere decir «no existe», y se crearía repetida.
  if (ERROR_CATALOGO || CREACION_INCIERTA){
    aviso('#edProdMsg', 'bad', 'No se pudo leer el catálogo, así que no se sabe qué marcas, subcategorías, ' +
      'líneas y colores ya existen. Cambiá de pestaña y volvé antes de guardar.');
    return;
  }
  const txt = (sel: string) => ($(sel).value || '').trim();
  const nulo = (v: string) => v === '' ? null : v;
  const d: Record<string, unknown> = {};
  //  Tal cual se escribe: en el catálogo real hay códigos en minúsculas, y
  //  la importación los compara exacto (D204).
  if (txt('#edCodigo') !== p.codigo) d.codigo = txt('#edCodigo');
  if (txt('#edDesc') !== p.descripcion) d.descripcion = txt('#edDesc');
  const cat = Number($('#edCat').value) || null;
  if (cat !== p.categoria_id) d.categoria_id = cat;
  if (nulo(txt('#edModelo')) !== (p.modelo ?? null)) d.modelo = nulo(txt('#edModelo'));
  if (nulo(txt('#edCapacidad')) !== (p.capacidad ?? null)) d.capacidad = nulo(txt('#edCapacidad'));
  if (nulo(txt('#edNroParte')) !== (p.ficha.nro_parte ?? null)) d.nro_parte = nulo(txt('#edNroParte'));
  const minimo = Number($('#edStockMin').value || 0);
  if (minimo !== p.ficha.stock_minimo) d.stock_minimo = minimo;
  const serie = $('#edSerie').value === 'true';
  if (serie !== !!p.es_serializado) d.es_serializado = serie;
  //  Vacío no borra el precio: un precio no se borra, se reemplaza.
  if ($('#edPrecio').value !== '' && Number($('#edPrecio').value) !== Number(p.precio_vigente ?? NaN))
    d.precio = Number($('#edPrecio').value);

  const btn = $('#btnEdProd');
  btn.disabled = true;
  try {
    //  Se crean (como en el alta) sólo si se escribió otra cosa.
    if (d.categoria_id !== undefined || !igualNombre(txt('#edSubcat'), p.subcategoria))
      d.subcategoria_id = await idPorNombre('subcategorias', SUBCATS, txt('#edSubcat'), { categoria_id: cat });
    if (!igualNombre(txt('#edMarca'), p.marcaMostrada)) d.marca_id = await idPorNombre('marcas', MARCAS, txt('#edMarca'));
    if (!igualNombre(txt('#edLinea'), p.linea)) d.linea_id = await idPorNombre('lineas', LINEAS, txt('#edLinea'));
    if (!igualNombre(txt('#edColor'), p.color)) d.color_id = await idPorNombre('colores', COLORES, txt('#edColor'));
  } catch (err){ btn.disabled = false; aviso('#edProdMsg', 'bad', err.message); return; }

  if (Object.keys(d).length === 0){
    btn.disabled = false;
    aviso('#edProdMsg', 'ok', 'No cambiaste nada.');
    return;
  }
  const { data, error } = await rpc('editar_producto', { p_producto_id: p.id, p_datos: d as any });
  btn.disabled = false;
  //  Si la base no contestó, quizá quedó guardado (D92): la lista se relee y
  //  lo tecleado se queda. Guardar de nuevo no duplica nada.
  if (noContesto(error)){
    aviso('#edProdMsg', 'warn', error.message + ' No se sabe si quedó guardado: fijate en la lista ' +
      'antes de volver a guardar.');
    cargarProductos();
    return;
  }
  if (error){ aviso('#edProdMsg', 'bad', error.message); return; }
  const r = (data ?? {}) as { mensaje?: string; avisos?: string[] };
  const avisos = r.avisos ?? [];
  cerrarFicha();
  avisoHtml('#catProdMsg', avisos.length ? 'warn' : 'ok',
    esc(r.mensaje ?? 'Producto guardado.') + avisos.map(a => '<br>' + esc(a)).join(''));
  cargarProductos();
};
